import PolicyPage from '../components/PolicyPage';

const JuryTermsPage = () => {
  return (
    <PolicyPage 
      title="Jury Terms and Conditions"
      metaTitle="Jury Terms and Conditions - Award Judging Guidelines"
      metaDescription="Review the jury terms and conditions for Golden Tree Events award programs. Covers judging criteria, confidentiality, conflict of interest, and jury member responsibilities."
      sourceUrl="https://gtedubai.com/app/jury-terms-and-conditions?awd=gte"
    />
  );
};

export default JuryTermsPage;
